import {
    Wallet,
    ArrowDownToLine,
    ArrowUpFromLine,
    TrendingUp,
    CircleDollarSign,
    ShieldCheck,
    CheckCircle2,
    Clock3,
    ArrowLeft,
    Landmark
} from "lucide-react";

import { useNavigate } from "react-router-dom";

import "./Earnings.scss";

export default function Earnings() {
    const navigate = useNavigate();

    const history = [
        {
            title: "Evento Corporativo",
            company: "Tech Solutions",
            value: "+ R$ 420,00",
            date: "Hoje • 14:20",
            status: "Concluído"
        },
        {
            title: "Garçom Freelancer",
            company: "Restaurante Itália",
            value: "+ R$ 180,00",
            date: "Ontem",
            status: "Concluído"
        },
        {
            title: "Recepcionista",
            company: "Hotel Plaza",
            value: "+ R$ 320,00",
            date: "23 Jun",
            status: "Concluído"
        }
    ];

    return (
        <div className="earnings">

            {/* HEADER */}

            <header className="earnings__header">

                <button
                    className="back-button"
                    onClick={() => navigate("/dashboard-freelancer")}
                >
                    <ArrowLeft size={18} />
                    Voltar ao Dashboard
                </button>

                <div>

                    <h1>Minha Carteira</h1>

                    <p>
                        Gerencie seus ganhos, acompanhe pagamentos e realize
                        saques com segurança.
                    </p>

                </div>

            </header>

            {/* CARD PRINCIPAL */}

            <section className="earnings__wallet">

                <div className="wallet-content">

                    <span className="wallet-badge">
                        Saldo disponível
                    </span>

                    <h2>R$ 2.485,00</h2>

                    <p>
                        Você já recebeu
                        <strong> R$ 18.930,00 </strong>
                        através da plataforma.
                    </p>

                    <small>
                        CPF •••.•••.•••-12
                    </small>

                </div>

                <div className="wallet-icon">

                    <Wallet size={70} />

                </div>

            </section>

            {/* ESTATÍSTICAS */}

            <section className="earnings__stats">

                <div className="stat">

                    <div className="stat-icon">
                        <TrendingUp />
                    </div>

                    <div>

                        <span>Ganhos este mês</span>

                        <h3>R$ 4.820,00</h3>

                    </div>

                </div>

                <div className="stat">

                    <div className="stat-icon waiting">
                        <Clock3 />
                    </div>

                    <div>

                        <span>Aguardando liberação</span>

                        <h3>R$ 850,00</h3>

                    </div>

                </div>

                <div className="stat">

                    <div className="stat-icon total">
                        <CircleDollarSign />
                    </div>

                    <div>

                        <span>Total recebido</span>

                        <h3>R$ 18.930,00</h3>

                    </div>

                </div>

            </section>

            {/* AÇÕES */}

            <section className="earnings__actions">

                <button className="withdraw">

                    <ArrowUpFromLine />

                    Sacar via Pix

                </button>

                <button className="deposit">

                    <ArrowDownToLine />

                    Adicionar saldo

                </button>

            </section>

            {/* HISTÓRICO */}

            <section className="earnings__history">

                <div className="section-title">

                    <h2>Últimas movimentações</h2>

                    <span>
                        Histórico recente de pagamentos.
                    </span>

                </div>

                {history.map((item, index) => (

                    <div
                        className="history-item"
                        key={index}
                    >

                        <div className="history-left">

                            <div className="history-icon">

                                <CheckCircle2 />

                            </div>

                            <div>

                                <strong>
                                    {item.title}
                                </strong>

                                <span>
                                    {item.company}
                                </span>

                            </div>

                        </div>

                        <div className="history-right">

                            <strong>
                                {item.value}
                            </strong>

                            <span>
                                {item.date}
                            </span>

                            <div className="status success">

                                {item.status}

                            </div>

                        </div>

                    </div>

                ))}

            </section>

            {/* COMO FUNCIONA */}

            <section className="earnings__info">

                <div className="section-title">

                    <ShieldCheck />

                    <div>

                        <h2>Como funciona sua carteira?</h2>

                        <span>
                            Transparência em cada pagamento.
                        </span>

                    </div>

                </div>

                <div className="info-grid">

                    <div className="info-card">

                        <Landmark />

                        <h4>Pagamento Seguro</h4>

                        <p>
                            Quando a empresa cria uma vaga, o valor permanece
                            protegido até a conclusão do serviço.
                        </p>

                    </div>

                    <div className="info-card">

                        <CheckCircle2 />

                        <h4>Conclusão Confirmada</h4>

                        <p>
                            Após a confirmação do trabalho realizado, o saldo é
                            liberado automaticamente para sua carteira.
                        </p>

                    </div>

                    <div className="info-card">

                        <ArrowUpFromLine />

                        <h4>Saque via Pix</h4>

                        <p>
                            Você pode solicitar um saque para a chave Pix
                            vinculada ao CPF cadastrado na plataforma.
                        </p>

                    </div>

                </div>

            </section>

        </div>
    );
}